export enum CheckoutSignatureStatus {
  None = 'N/A',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}
